// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TwoStepDeleteButton_buttonContainer__3bkJS","deleteButton":"TwoStepDeleteButton_deleteButton__WtjxN","expanded":"TwoStepDeleteButton_expanded__11YJ4"};